import AdvanceTable from "components/common/advance-table/AdvanceTable";
import CardDropdown from "components/common/CardDropdown";
import FalconPagination from "components/common/custom/pagination";
import useAdvanceTable from "hooks/useAdvanceTable";
import AdvanceTableProvider from "providers/AdvanceTableProvider";
import React, { useEffect, useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { Gear, Pen } from "react-bootstrap-icons";
import { nationalityData } from "../utils";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import paths from "routes/paths";
import ConfirmationModal from "components/common/custom/confirmation-modal";
import { useDispatch } from "react-redux";
import {
  DeletePractitioner,
  GetAllPractitionerList,
} from "../config/practitionerSliceAPi";
import { toast } from "react-toastify";

const PractitionersListTable = ({
  totalRows,
  handlePageChange,
  handlePerRowsChange,
  data,
  page,
  setting,
  rowsPerPage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalRow, setModalRow] = useState(null);

  const handleConfirmDelete = async () => {
    const response = await dispatch(
      DeletePractitioner(modalRow?.practitioner_id)
    ).unwrap();
    if (response?.success) {
      const body = {
        branch: "",
        name: "",
        license_number: "",
        speciality: "",
        id_number: "",
        start_point: 0,
        limit: rowsPerPage,
      };
      toast.success(response?.message_en);
      const res = await dispatch(GetAllPractitionerList(body)).unwrap();
    } else {
      toast.error(response?.message_en);
    }
  };

  const columns = [
    {
      accessorKey: "index",
      header: "#",
      cell: ({ row }) => (
        <div className="d-flex align-items-center w-100">
          <div
            className="rounded-circle bg-200 d-flex flex-center fs-11"
            style={{ width: "30px", height: "30px" }}
          >
            {page * rowsPerPage + row.index + 1}
          </div>
        </div>
      ),
    },
    {
      accessorKey: "name",
      header: "Practitioner Name",
      cell: ({ row: { original } }) =>
        `${original?.practitioner_firstname || ""} ${original?.practitioner_familyname
        }` || "-",
    },
    {
      accessorKey: "created",
      header: "Added On",
      cell: ({ row: { original } }) =>
        original?.created_at
          ? moment(original?.created_at).format("DD-MM-YYYY , hh:mm:ss")
          : "-",
    },
    {
      accessorKey: "license",
      header: "License No",
      cell: ({ row: { original } }) =>
        `${original?.practitioner_license || "-"}`,
    },
    {
      accessorKey: "expiry",
      header: "Expiry Date",
      cell: ({ row: { original } }) =>
        `${original?.practitioner_license_exp
          ? moment(original?.practitioner_license_exp).format("DD-MM-YYYY")
          : "-" || "-"
        }`,
    },
    {
      accessorKey: "speciality",
      header: "Speciality",
      cell: ({ row: { original } }) => `${original?.specialities_name || "-"}`,
    },
    {
      accessorKey: "national",
      header: "National ID",
      cell: ({ row: { original } }) =>
        `${original?.practitioner_nationalid || "-"}`,
    },
    {
      accessorKey: "nationaliy",
      header: "	Nationality",
      cell: ({ row: { original } }) =>
        `${original?.practitioner_nationality || "-"}`,
    },
    {
      accessorKey: "mobile",
      header: "Mobile Number",
      cell: ({ row: { original } }) =>
        `${original?.practitioner_mobilenumber || "-"}`,
    },
    {
      accessorKey: "branch",
      header: "Branch Name",
      cell: ({ row: { original } }) => `${original?.brname || "-"}`,
    },
    {
      accessorKey: "actions",
      header: <Gear />,
      enableSorting: false,
      cell: ({ row: { original } }) => {
        return (
          <>
            {(Number(setting?.view) === 1 || Number(setting?.edit) === 1 || Number(setting?.delete) === 1) && (
              <CardDropdown
                icon="ellipsis-v"
                dropdownClassName="py-2 custom-dropdown-menu"
              >
                {Number(setting?.view) === 1 && (
                  <Dropdown.Item
                    onClick={() =>
                      navigate(
                        `${paths.addPractitionerList}/${original?.practitioner_id}/view`
                      )
                    }
                  >
                    <FontAwesomeIcon icon="eye" className="me-2" />
                    View
                  </Dropdown.Item>
                )}
                {Number(setting?.edit) === 1 && (
                  <Dropdown.Item
                    onClick={() =>
                      navigate(
                        `${paths.addPractitionerList}/${original?.practitioner_id}`
                      )
                    }
                  >
                    <Pen className="me-2" />
                    Edit
                  </Dropdown.Item>
                )}
                {Number(setting?.delete) === 1 && (
                  <Dropdown.Item
                    onClick={() => {
                      setShowDeleteModal(true);
                      setModalRow(original);
                    }}
                  >
                    <FontAwesomeIcon icon="trash" className="me-2" />
                    Delete
                  </Dropdown.Item>
                )}
              </CardDropdown>
            )}
          </>
        );
      },
    },
  ];
  const table = useAdvanceTable({
    data,
    columns,
    manualPagination: true,
    pageCount: Math.ceil(totalRows / rowsPerPage),
    state: {
      pagination: {
        pageIndex: page,
        pageSize: rowsPerPage,
      },
    },
  });

  useEffect(() => {
    table.setPagination({ pageIndex: page, pageSize: rowsPerPage });
  }, [page, rowsPerPage]);

  return (
    <div className="mb-3 mt-3 border">
      {data?.length > 0 ? (
        <>
          <AdvanceTableProvider {...table}>
            <AdvanceTable
              tableProps={{
                size: "sm",
                className: "fs-10 mb-0 overflow-hidden",
                striped: true,
              }}
              headerClassName="bg-200 text-nowrap align-middle"
              rowClassName="align-middle white-space-nowrap"
            />
          </AdvanceTableProvider>
          <Card.Footer className="d-flex mt-2 mb-3 justify-content-end align-items-center">
            <FalconPagination
              currentPage={page}
              rowsPerPage={rowsPerPage}
              totalRecords={totalRows}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePerRowsChange}
            />
          </Card.Footer>
        </>
      ) : (
        <div className="text-center py-3">No Data To Show</div>
      )}

      <ConfirmationModal
        modal={showDeleteModal}
        setModal={setShowDeleteModal}
        onConfirm={handleConfirmDelete}
        title="Confirm Delete"
        description="Are you sure you want to delete this record?"
      />
    </div>
  );
};

export default PractitionersListTable;
